module.exports = __webpack_public_path__ + "img/TZS09427.418cd6e3.jpeg";